export enum GlacierRestoreTiers {
  Expedited = 0,
  Standard = 1,
  Bulk = 2
}
